import { Box, ButtonBase, Typography } from "@mui/material";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const cacheltr = createCache({
  key: "muiltr",
  stylisPlugins: [],
});

function BalootKeyboard({ sx = [], ...props }) {
  const { setAmount = () => {}, maxLength = 10 } = props;

  return (
    <Box
      sx={[
        {
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <CacheProvider value={cacheltr}>
        <Box
          sx={{
            direction: "ltr",
            width: 244,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}
        >
          {Array.apply(null, Array(9)).map((_, index) => {
            return (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexBasis: "30%",
                }}
              >
                <ButtonBase
                  onClick={() => {
                    setAmount((prev) =>
                      prev.toString().length === 10
                        ? prev
                        : parseInt(prev.toString() + (index + 1).toString())
                    );
                  }}
                  sx={{ width: 60, height: 60, borderRadius: "100%" }}
                >
                  <Typography variant="h2" color="grey.2">
                    {index + 1}
                  </Typography>
                </ButtonBase>
              </Box>
            );
          })}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexBasis: "30%",
            }}
          ></Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexBasis: "30%",
            }}
          >
            <ButtonBase
              onClick={() => {
                setAmount((prev) =>
                  prev.toString().length === 10
                    ? prev
                    : parseInt(prev.toString() + "0")
                );
              }}
              sx={{ width: 60, height: 60, borderRadius: "100%" }}
            >
              <Typography variant="h2" color="grey.2">
                0
              </Typography>
            </ButtonBase>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexBasis: "30%",
            }}
          >
            <ButtonBase
              onClick={() => {
                setAmount((prev) =>
                  parseInt(
                    prev.toString().length === 1
                      ? 0
                      : prev.toString().slice(0, -1)
                  )
                );
              }}
              sx={{ width: 60, height: 60, borderRadius: "100%" }}
            >
              <ArrowBackIcon sx={{ color: "grey.4" }} />
            </ButtonBase>
          </Box>
        </Box>
      </CacheProvider>
    </Box>
  );
}

export default BalootKeyboard;
